import {
  awaitAnimate,
  Particle,
  ParticleModes,
} from "../../../engine/anims/Particle";
import Colors from "../../Colors";

export const AcceptedWordParticle = {
  mode: ParticleModes.DRAW_OVER_LAST,
  char: null,
  fg: Colors.WHITE,
  bg: null,
  animate: async (particle: Particle<string>) => {
    await new Promise((r) => setTimeout(r, 50));

    await awaitAnimate({
      driver: particle.driver,
      from: Colors.WHITE,
      to: particle.options || Colors.RED,
      duration: 200,
      onUpdate: (latest) => {
        particle.fg = latest;
      },
    });
  },
};
